import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../lib/Errors';

let localSubscription = undefined;

function createSubscription(store) {
	let dataQuery = new Parse.Query('MedicationICD10Code');
	dataQuery.notEqualTo("deleted", true)
	dataQuery.addAscending("icd_10_code")
	dataQuery.find()
		.then((results) => {
			store.dispatch('icd_10_codes/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
		dataQuery.subscribe().then((subscription) => {
		
		localSubscription = subscription;

		subscription.on('create', object => {
			
			store.dispatch('icd_10_codes/insert', object)
		});
		subscription.on('update', object => {
			
			store.dispatch('icd_10_codes/replace', object)
		});
		subscription.on('enter', object => {
			
			store.dispatch('icd_10_codes/insert', object)
		});
		subscription.on('leave', object => {
			
			store.dispatch('icd_10_codes/delete', object)
		});
		subscription.on('delete', object => {
			
			store.dispatch('icd_10_codes/delete', object)
		});
		subscription.on('close', () => {
		});
		subscription.on('error', error => {
            console.log('ICD10Codes subscription error', error);
        })
	})
}

export default function createICD10CodeSubscription() {
	return store => {
		if (store.state.currentUser) {
			createSubscription(store)
		}
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER') {
				if (localSubscription) {
					localSubscription.unsubscribe()
				}
				if (store.state.currentUser) {
					createSubscription(store)
				}
			}
		})
	}
}
